<template>
    <AdditionalDescription 
        :entity-type="BUSINESS_TYPE.ENTITY"
        :entity-id="+$route.params.id">
        <template v-slot:tabs>
            <EntityTabLinks />
        </template>
    </AdditionalDescription>
</template>

<script>
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import AdditionalDescription from '@/components/additional-description/AdditionalDescription';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityAdditionalDescription',

        components: {
            EntityTabLinks,
            AdditionalDescription
        },
  
        data () {
            return {
                BUSINESS_TYPE,
            }
        },
    
        computed: {},

        async mounted() {
        },

        methods: {}
    }
</script>
